<template>
    <div class="BillingLayout" v-if="UserPrivateProfile.UserId">
        <div>
            <nav class="navbar navbar-light navbar-expand-md navigation-clean">
                <div class="container-fluid">
                    <a id="navbar-brand" class="navbar-brand pointer"><router-link to="/"><img v-bind:src="sitelogo" /></router-link></a><button data-toggle="collapse" class="navbar-toggler" data-target="#navcol-1"><span class="sr-only">Toggle navigation</span><span class="navbar-toggler-icon"></span></button>
                    <div class="collapse navbar-collapse"
                         id="navcol-1">
                        <b-nav pills class="ml-auto" style="margin-right:50px;">
                            <b-nav-item class="hidden" role="presentation"></b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('InvoicePane')" v-bind:class="{ active: PaneShown == 'InvoicePane' }"><font-awesome-icon :icon="['fa', 'file-invoice-dollar']" /> Invoices</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('ProviderPane')" v-bind:class="{ active: PaneShown == 'ProviderPane' }"><font-awesome-icon :icon="['fa', 'users']" /> Providers</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('ReportsPane')" v-bind:class="{ active: PaneShown == 'ReportsPane' }"><font-awesome-icon :icon="['fa', 'chart-bar']" /> Reports</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('FileUploadPane')" v-bind:class="{ active: PaneShown == 'FileUploadPane' }"><font-awesome-icon :icon="['fa', 'file-upload']" /> File Uploads</b-nav-item>
                            <b-nav-item><Logout /></b-nav-item>
                        </b-nav>
                    </div>
                </div>
            </nav>
        </div>

        <div class="tab-content col-12 padding-adjust-for-overlay-scroll">
            <div class="tab-pane fade active show" role="tabpanel" id="tab-home">
                <div id="FosterHomeTab">

                </div>
            </div>
            <div v-if="PaneShown == 'InvoicePane'">
                <InvoicePane />
            </div>
            <div v-if="PaneShown == 'ProviderPane'">
                <ProviderPane />
            </div>
            <div v-show="PaneShown == 'FileUploadPane'">
                <FileUploadPane />
            </div>
            <div v-show="PaneShown == 'ReportsPane'">
                <ReportsPane />
            </div>
        </div>
        <!--Logged in User-->
        <p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>
    </div>
</template>

<script>
    //import services
    import { UserAPI } from '../../../services/api/Core/UserAPI.js';
    //import components

    import InvoicePane from '../Billing/InvoicePane.vue';
    import ProviderPane from '../Billing/Provider/ProviderPane.vue';
    import FileUploadPane from '../Billing/FileUploadPane.vue';
    import ReportsPane from '../Billing/ReportsPane.vue';
    import Logout from '../../Core/UI/Logout.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileInvoiceDollar);
    import { faFileUpload } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileUpload);
    import { faChartBar } from '@fortawesome/free-solid-svg-icons';
    library.add(faChartBar);
    
    
    export default {
        name: "MentalHealthLayout",
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
            this.$store.commit("User.PrivateProfile.Clear");
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_Billing.png",
                PaneShown: "ReportsPane"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            GetEmployeePrivateProfile() {
                let vm = this;
                vm.$store.commit("UI.BumpLoadsInProgress", 1);
                this.userAPI.GetEmployeePrivateProfile().then((data) => {
                    vm.$store.commit("UI.BumpLoadsInProgress", -1);
                    data.data.AssignedSubPrograms = data.data.AssignedSubPrograms.filter(sp => sp.HasClients);
                    this.$store.commit("User.PrivateProfile.Replace", data.data);
                });
            }
        },
        components: {
            InvoicePane,
            ProviderPane,
            FileUploadPane,
            ReportsPane,
            Logout
        },
        mounted() {
            this.GetEmployeePrivateProfile();
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            }
        }
    }
</script>

<style scoped>
    .upper-right {
        position:absolute;
        top:0;
        right:40px;
    }

    .BillingLayout {
        background-color: #605271;
    }
</style>